import { TFunction } from 'i18next'

const API_URL: string = import.meta.env.VITE_API_URL as string

export const ADMIN_API_ROOT = `${API_URL}/admin`
export const CUSTOMS_API_ROOT = `${API_URL}/customs-officer`

export const ADMIN_API_URL = {
  DOWNLOAD: `${ADMIN_API_ROOT}/download`,
  AUTH: {
    SIGNIN: `${ADMIN_API_ROOT}/auth/signin`,
    SIGNUP: `${ADMIN_API_ROOT}/auth/signup`,
    VALIDATE_OTP: `${ADMIN_API_ROOT}/auth/validate-otp`,
  },
  PURCHASE: {
    ROOT: `${ADMIN_API_ROOT}/purchase`,
    LIST: `${ADMIN_API_ROOT}/purchase/search`,
  },
  ORDER: {
    ROOT: `${ADMIN_API_ROOT}/certificate`,
  },
  CUSTOMER: {
    ROOT: `${ADMIN_API_ROOT}/user`,
  },
  CUSTOMS_CROSSING: {
    ROOT: `${ADMIN_API_ROOT}/customs-crossing`,
  },
  CUSTOMS_VARIABLE: {
    ROOT: `${ADMIN_API_ROOT}/customs-variable`,
  },
  BUYER: {
    ROOT: `${ADMIN_API_ROOT}/buyer`,
  },
  SELLER: {
    ROOT: `${ADMIN_API_ROOT}/seller`,
    SEARCH: `${ADMIN_API_ROOT}/seller/search`,
    EORI: `${ADMIN_API_ROOT}/seller/eori`,
  },
  EUR1_COUNTER: {
    ROOT: `${ADMIN_API_ROOT}/eur1Counter`,
  },
  BLACKLIST: {
    ROOT: `${ADMIN_API_ROOT}/blacklist`,
  },
  FACTURE: {
    ROOT: `${ADMIN_API_ROOT}/facture`,
    SEARCH: `${ADMIN_API_ROOT}/facture/search`,
    MONTHLY_DOWNLOAD: `${ADMIN_API_ROOT}/facture/monthly-download`,
  },
  INCOME: {
    ROOT: `${ADMIN_API_ROOT}/income`,
  },
  INCOME_STATISTICS: {
    ROOT: `${ADMIN_API_ROOT}/income/statistics`,
  },
  STORAGE_PLACE: {
    ROOT: `${ADMIN_API_ROOT}/storage-place`,
  },
  DHL: {
    ROOT: `${ADMIN_API_ROOT}/dhl`,
  },
  USER: {
    ROOT: `${ADMIN_API_ROOT}/user`,
  },
  VPN: {
    ROOT: `${ADMIN_API_ROOT}/vpn`,
  },
  MESSAGES: {
    ROOT: `${ADMIN_API_ROOT}/vpn/messages`,
  },
  E_SIGN: {
    ROOT: `${ADMIN_API_ROOT}/sign-request`,
  },
  CUSTOMS: {
    CUSTOMS_TRANSACTION: `${ADMIN_API_ROOT}/customs-transaction`,
    CUSTOMS_DELTA_HISTORY: `${ADMIN_API_ROOT}/customs-delta/history`,
  },
  PRICE: {
    ROOT: `${ADMIN_API_ROOT}/price`,
  },
  DEBLOCAGE: {
    ROOT: `${ADMIN_API_ROOT}/deblocage`,
  },
  LOG: {
    ROOT: `${ADMIN_API_ROOT}/log`,
    CERTIFICATE: `${ADMIN_API_ROOT}/log/certificate`,
    PURCHASE: `${ADMIN_API_ROOT}/log/purchase`,
    SELLER: `${ADMIN_API_ROOT}/log/seller`,
    BUYER: `${ADMIN_API_ROOT}/log/buyer`,
    USER: `${ADMIN_API_ROOT}/log/user`,
    FORWARDER: `${ADMIN_API_ROOT}/log/forwarder`,
  },
  EXTERNAL_USER: {
    ROOT: `${ADMIN_API_ROOT}/external-user`,
  },
  INTERNAL_REVISION: {
    PURCHASE: `${ADMIN_API_ROOT}/internal-revision/purchase`,
    ORDER: `${ADMIN_API_ROOT}/internal-revision/certificate`,
  }
}

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const getTranslateMonthNames = (t: TFunction) => [
  t('translation:common.months.january'),
  t('translation:common.months.february'),
  t('translation:common.months.march'),
  t('translation:common.months.april'),
  t('translation:common.months.may'),
  t('translation:common.months.June'),
  t('translation:common.months.july'),
  t('translation:common.months.august'),
  t('translation:common.months.september'),
  t('translation:common.months.october'),
  t('translation:common.months.november'),
  t('translation:common.months.december'),
]

export const getVehicleTypeOptions = (t: TFunction) => [
  { value: 'TRUCK', label: t('translation:common.label.truck') },
  { value: 'VEHICLE', label: t('translation:common.label.vehicle') },
]

export const getTranslate_default_reserved_names = (t: TFunction) => [
  t('translation:common.label.gray_card'),
  t('translation:common.label.invoice'),
  t('translation:form.placeholder.delivery_note'),
  t('translation:form.placeholder.driving_licence'),
  t('translation:form.placeholder.business_registry'),
  t('translation:common.label.swift'),
]

export const customsTransactionStatuses = {
  creationDauValide: 'CREATION_DAU_VALIDE',
  ValidationDauEnAttente: 'VALIDATION_DAT_EN_ATTENTE',
  AnnulationDau: 'ANNULATION_DAU',
  InvalidationDau: 'INVALIDATION_DAU',
  ValidationDauAnticipe: 'VALIDATION_DAT_ANTICIPE',
}

export const mapCustomsTransactionStatuses = {
  CREATION_DAU_VALIDE: 'Création DAU validé',
  VALIDATION_DAU_EN_ATTENTE: 'Validation DAU en attente',
  ANNULATION_DAU: 'Annulation DAU',
  INVALIDATION_DAU: 'Invalidation DAU',
  RECTIFICATION_DAU: 'Rectification DAU',
  VALID_RECTIFICATION: 'Rectification validée',
  ANNUAL_RECTIFICATION: 'Rectification annuelle',
  VALIDATION_DAT_ANTICIPE: 'Validation DAU anticipé',
  MODIFICATION_PAIEMENT_DAU: 'Modification du paiement DAU',
  CREATION_DAU_SECOURS: "Création d'un DAU de secours",
  CREATION_DAU_ANTICIPE: "Création d'un DAU anticipé",
  MODIFICATION_DAU: 'Modification du DAU',
  DEMANDE_CONFIRMATION_SORTIE: 'Demande de confirmation de sortie',
  BAEADC: 'BAE - En attente de déclaration complémentaire',
  CREATION_DAU_COMPLEMENTAIRE: "Création d'un DAU complémentaire",
  PRESENTATION_NOTIFICATION: 'Notification de présentation',
  SOUSCONTROLE: 'Sous contrôle',
  CREATION_DAU_SECOURS_ANTICIPE: "Création d'un DAU de secours anticipé",
  CREATION_DAU_DSR: 'Création DAU DSR',
  CONFIRMATION_NON_SORTIE: 'Confirmation non sortie',
  DEMANDE_PROLONGATION_POUR_SORTIE: 'Demande prolongation pour sortie',
  SORTIE_CONFIRMEE_SANS_PREUVES: 'Sortie confirmée sans preuves',
  SORTIE_CONFIRMEE_AVEC_PREUVES: 'Sortie confirmée avec preuves',
  ANT: 'Anticipé',
  ANN: 'Annulé',
  BAE: 'Bon à enlever',
  CEA: 'Crédit en attente',
  DIN: "Demande d'invalidation",
  DRE: 'Demande de rectification',
  EAV: 'En attente de validation',
  INV: 'Invalide',
  MND: 'Marchandise non dédouanée',
  PCO: 'Paiement au comptant',
  VAL: 'Validé',
  REV: 'Validé Révisé',
  // ETATS DEMANDES (ex: demande de rectification)
  ACC: 'Acceptée',
  ENC: 'En cours',
  REF: 'Refusée',
  DEA: 'Demande en attente de validation',
  DAN: 'Demande annulée',
  // ETATS MARCHANDISE (ECS)
  SOR: 'Sortie',
  ENF: 'ECS Non finalisé',
  EEC: 'ECS En cours de sortie',
  EEX: 'ECS Expiré',
  ESO: 'ECS Sortie',
  ESD: 'ECS Sortie avec différences',
  EBL: 'ECS Bloqué',
  EAN: 'ECS Annulé',
  HEC: 'HORS ECS',
  // ERROR
  ERROR: 'Erreur',
}

export const customsTransactionStatusOptions = [
  {
    label: 'Creation Dau Valide',
    value: 'CREATION_DAU_VALIDE',
  },
  {
    label: 'Validation Dau En Attente',
    value: 'VALIDATION_DAU_EN_ATTENTE',
  },
  {
    label: 'Annulation Dau',
    value: 'ANNULATION_DAU',
  },
  {
    label: 'Invalidation Dau',
    value: 'INVALIDATION_DAU',
  },
  {
    label: 'Rectification dau',
    value: 'RECTIFICATION_DAU',
  },
  {
    label: 'Valid rectification',
    value: 'VALID_RECTIFICATION',
  },
  {
    label: 'Annual rectification',
    value: 'ANNUAL_RECTIFICATION',
  },
  {
    label: 'Creation dau anticipe',
    value: 'CREATION_DAU_ANTICIPE',
  },
  {
    label: 'Validation Dau Anticipe',
    value: 'VALIDATION_DAT_ANTICIPE',
  },
  {
    label: 'Modification paiement dau',
    value: 'MODIFICATION_PAIEMENT_DAU',
  },
  {
    label: 'Creation dau secours',
    value: 'CREATION_DAU_SECOURS',
  },
  {
    label: 'Modification dau',
    value: 'MODIFICATION_DAU',
  },
]

export const getWorkingStatusTranslation = (t: TFunction) => ({
  NOT_PROCESSED: t('translation:common.status.not_processed'),
  IN_PROGRESS: t('translation:common.status.in_progress'),
  IN_REVIEW: t('translation:common.status.in_review'),
  REVIEWED: t('translation:common.status.reviewed'),
  PROCESSED: t('translation:common.status.processed'),
})

export const vehicleFields = [
  'brand',
  'model',
  'firstRegistrationAt',
  'year',
  'registration',
  'vin',
  'weight',
  'numberOfKm',
  'invoiceNumber',
  'price',
  'nomenclature',
  'meansOfTransport',
  'meansOfTransportNationality',
  'meansOfTransportRegistration',
  'storagePlace',
  'euExitPlace',
  'vehicleLicenceNumber',
]

export const paymentStatusOptions = (t: TFunction) => [
  {
    value: 'PAID',
    label: t('translation:common.status.paid'),
  },
  {
    value: 'NOT_PAID',
    label: t('translation:common.status.not_paid'),
  },
  {
    value: 'FAILED',
    label: t('translation:common.status.failed'),
  },
]
